import { SORT_DIRECTIONS } from "../../utils/TableConstants";

import useTableData from "../../../../state/table/UseTableData";

const useTableSortHeader = (sortKey) => {
  const { tableState, onUpdateTableSort } = useTableData();

  const onHeaderClicked = (e, sortType) => {
    e?.preventDefault();
    e?.stopPropagation();

    onUpdateTableSort(sortKey, sortType, getNewSortDirection());
  };

  function getNewSortDirection() {
    if (sortKey === tableState.sortKey) {
      if (tableState.sortDirection === SORT_DIRECTIONS.ASCENDING) { // second click
        return SORT_DIRECTIONS.DESCENDING;
      } else if (tableState.sortDirection === SORT_DIRECTIONS.DESCENDING) { // third click
        return '';
      } else {
        return SORT_DIRECTIONS.ASCENDING;
      }
    } else { // first click
      return SORT_DIRECTIONS.ASCENDING
    }
  }

  return {
    isSortedHeader: tableState.sortKey === sortKey,
    sortDirection: tableState.sortDirection,
    onHeaderClicked
  };
};

export default useTableSortHeader;